import axios from '../../../axios';
import { Field } from '../types/Field';

const url = 'invoicingservice/api/client-custom-field';

export const getAllClientCustomFields = () => axios.get<Field[]>(url);
export const createClientCustomField = (field: Field) => axios.post(url, field);
export const updateClientCustomField = (field: Field) => axios.put(url, field);
